var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb-3"},[_c('BoxContainer',{staticClass:"loading__box"},[_c('ExLoading',{staticClass:"loading_accordion rounded",attrs:{"width":"100%","maxWidth":"100%","height":"4rem","animationDuration":"1.3s"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }